import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["secondary", "onClose"];
import React from 'react';
import PT from 'prop-types';
import CrossIcon from '@scaleflex/icons/cross';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import Styled from './modal-title.styles';
import { Variant } from './types';
var ModalTitle = intrinsicComponent(function (_ref, ref) {
  var secondary = _ref.secondary,
      onClose = _ref.onClose,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Styled.ModalTitle, _extends({}, rest, {
    ref: ref
  }), rest.icon && /*#__PURE__*/React.createElement(Styled.Icon, {
    iconShadow: Boolean(rest.iconShadow)
  }, rest.icon), /*#__PURE__*/React.createElement(Styled.LabelPrimary, null, rest.primary), rest.variant === Variant.WithIcon && secondary && /*#__PURE__*/React.createElement(Styled.LabelSecondary, null, secondary), /*#__PURE__*/React.createElement(Styled.Close, {
    variant: rest.variant,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CrossIcon, {
    size: 11
  })));
});
ModalTitle.defaultProps = {
  iconShadow: true,
  variant: Variant.Default
};
ModalTitle.propTypes = {
  primary: PT.node.isRequired,
  secondary: PT.node,
  icon: PT.node,
  iconShadow: PT.bool,
  onClose: PT.func,
  variant: PT.oneOf(objectValues(Variant))
};
ModalTitle.displayName = 'ModalTitle';
export default ModalTitle;